"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonNotification = void 0;
const React = require("react");
const BronsonNotification = ({ onClose, isVisible, title, description, type, }) => {
    return (React.createElement("div", { "data-component": 'dh-notification-full-screen', className: `c-notification__container js-notification-container ${isVisible ? '' : 'is-closed'}` },
        React.createElement("div", { className: `c-notification  c-notification--${type}` },
            React.createElement("div", { className: 'c-notification__outer-wrap' },
                React.createElement("div", { className: 'c-notification__inner-wrap' },
                    React.createElement("i", { className: 'c-notification__status-icon', "aria-hidden": 'true', role: 'img' }),
                    React.createElement("div", { className: 'c-notification__content' },
                        React.createElement("h3", { className: 'c-notification__title' }, title),
                        React.createElement("p", { className: 'c-notification__text' }, description)),
                    onClose && (React.createElement("button", { "data-component": 'dh-notification-close-btn', className: 'js-notification-close  c-notification__close', onClick: onClose })))))));
};
exports.BronsonNotification = BronsonNotification;
